import { useMemo } from 'react';

import { getOrderedWidgetData } from './utils';

export const useOrderedWidgetData = (
  data: any,
  rangeType: string,
  type: number,
  apartmentTypeGroups: any,
  groupBy: any
) => {
  return useMemo(() => {
    return getOrderedWidgetData(data, rangeType, type, apartmentTypeGroups, groupBy);
  }, [data, rangeType, type, apartmentTypeGroups]);
};
